import config from '../config.json';

export const formatNumber = (value) =>
    Number(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: config.DISPLAYED_DECIMALS
    });